import { Injectable } from '@angular/core';
import { IBreadcrumbItem } from "libraries/service/breadcrumb/IBreadcrumbItem";
import { Yii } from "libraries/interfaces/Yii";
import { EQuotationEntryPoints } from "libraries/enums/e-quotation-entry-points";

@Injectable()
export class QuotationBreadcrumbService {

    private items: IBreadcrumbItem[] = [
        {
            isActive: true,
            isClickable: false,
            name: Yii.t('wui-quotation-js', 'Achat inclus'),
            action: EQuotationEntryPoints.cost,
        },
        {
            isActive: false,
            isClickable: true,
            name: Yii.t('wui-quotation-js', 'Vente inclus'),
            action: EQuotationEntryPoints.retail,
        },
        {
            isActive: false,
            isClickable: false,
            name: Yii.t('wui-quotation-js', 'Achat en option'),
            action: null,
        },
        {
            isActive: false,
            isClickable: false,
            name: Yii.t('wui-quotation-js', 'Vente en option'),
            action: null,
        },
    ];


    public activateItem(itemIndex: number): IBreadcrumbItem[] {
        return this.items.map((item: IBreadcrumbItem, index: number) => {
            if (item.isActive) {
                item.isClickable = true;
                item.isActive = false;
            }

            if (index === itemIndex) {
                item.isActive = true;
            }

            return item;
        });

    }
}
